import React from 'react';
import CodeMirror, { EditorView } from "@uiw/react-codemirror";
import { rust } from "@codemirror/lang-rust";
import { useFileContents } from '../Utils'
import {
    trait_impl_file,
    impl_file,
    impl_with_generic_file,
    trait_impl_with_generic_file,
    test_file,
    derive_file,
    new_type_file,
    enum_file,
    if_let_file,
} from '../RustCode';
import { InlineMath } from 'react-katex';

export const RustPage: React.FC<{}> = () => {
    const traitImpl = useFileContents(trait_impl_file as any);
    const normalImpl = useFileContents(impl_file as any);
    const implWithGeneric = useFileContents(impl_with_generic_file as any);
    const traitImplWithGeneric = useFileContents(trait_impl_with_generic_file as any);
    const test = useFileContents(test_file as any);
    const derive = useFileContents(derive_file as any);
    const newType = useFileContents(new_type_file as any);
    const enumExample = useFileContents(enum_file as any);
    const ifLetExample = useFileContents(if_let_file as any);


    return (
        <main>
            <h1>Rust Cheat Sheet</h1>
            <p>
                I enjoy using Rust but sometimes I forget a small bit of syntax. If I find myself consistently forgetting
                that syntax, I add it to this cheat sheet and it's way faster than searching for it.
            </p>
            <h3>Trait Impls </h3>
            <CodeMirror
                value={traitImpl}
                extensions={[rust(), EditorView.editable.of(false)]}
                height="60px"
                theme={'dark'}
            />
            What is a bit confusing is that when it's just an <InlineMath math="\texttt{impl}" /> without a trait, the type goes right after
            <CodeMirror
                value={normalImpl}
                extensions={[rust(), EditorView.editable.of(false)]}
                height="60px"
                theme={'dark'}
            />
            If you have a generic used, it needs to come after the <InlineMath math="\texttt{impl}" />
            <CodeMirror
                value={implWithGeneric}
                extensions={[rust(), EditorView.editable.of(false)]}
                height="60px"
                theme={'dark'}
            />
            More complicated example:
            <CodeMirror
                value={traitImplWithGeneric}
                extensions={[rust(), EditorView.editable.of(false)]}
                height="60px"
                theme={'dark'}
            />
            <h3>Tests</h3>
            <CodeMirror
                value={test}
                extensions={[rust(), EditorView.editable.of(false)]}
                height="600px"
                theme={'dark'}
            />
            <h3>Derive</h3>
            <CodeMirror
                value={derive}
                extensions={[rust(), EditorView.editable.of(false)]}
                height="60px"
                theme={'dark'}
            />
            <h3>New Types</h3>
            <CodeMirror
                value={newType}
                extensions={[rust(), EditorView.editable.of(false)]}
                height="180px"
                theme={'dark'}
            />
            <h3>Enum Discrimination</h3>
            <CodeMirror
                value={enumExample}
                extensions={[rust(), EditorView.editable.of(false)]}
                height="400px"
                theme={'dark'}
            />
            <h3>If let / else</h3>
            <CodeMirror
                value={ifLetExample}
                extensions={[rust(), EditorView.editable.of(false)]}
                theme={'dark'}
            />
        </main>
    )
};
